module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("学生管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("体验名单")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 110,
      "show-message": false,
      "label-position": "right"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "创建时间："
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.startTimeDate),
      callback: function($$v) {
        _vm.startTimeDate = $$v
      },
      expression: "startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v(" -")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.endTimeDate),
      callback: function($$v) {
        _vm.endTimeDate = $$v
      },
      expression: "endTimeDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "昵称：",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "nickname"
    },
    model: {
      value: (_vm.queryParam.nickname),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "nickname", $$v)
      },
      expression: "queryParam.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "推荐人ID：",
      "prop": "inviteId"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "不支持模糊查询",
      "name": "inviteId"
    },
    model: {
      value: (_vm.queryParam.inviteId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "inviteId", $$v)
      },
      expression: "queryParam.inviteId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "推荐人学导名称：",
      "prop": "referrerStudyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊查询",
      "name": "referrerStudyAdviserName"
    },
    model: {
      value: (_vm.queryParam.referrerStudyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "referrerStudyAdviserName", $$v)
      },
      expression: "queryParam.referrerStudyAdviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID：",
      "prop": "uid"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "不支持模糊搜索",
      "name": "mobile"
    },
    model: {
      value: (_vm.queryParam.uid),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "uid", $$v)
      },
      expression: "queryParam.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "联系电话：",
      "prop": "mobile"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "mobile"
    },
    model: {
      value: (_vm.queryParam.mobile),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "mobile", $$v)
      },
      expression: "queryParam.mobile"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "归属活动："
    }
  }, [_c('activity-select', {
    model: {
      value: (_vm.queryParam.stdTab),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "stdTab", $$v)
      },
      expression: "queryParam.stdTab"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "微信号：",
      "prop": "wechatAccount"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "wechatAccount"
    },
    model: {
      value: (_vm.queryParam.wechatAccount),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "wechatAccount", $$v)
      },
      expression: "queryParam.wechatAccount"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道："
    }
  }, [_c('channel-select', {
    model: {
      value: (_vm.queryParam.regType),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "regType", $$v)
      },
      expression: "queryParam.regType"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 6
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "市场专员",
      "prop": "marketUserId"
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "market"
    },
    model: {
      value: (_vm.queryParam.marketUserId),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "marketUserId", $$v)
      },
      expression: "queryParam.marketUserId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 8
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "注册备注：",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "remark"
    },
    model: {
      value: (_vm.queryParam.remark),
      callback: function($$v) {
        _vm.$set(_vm.queryParam, "remark", $$v)
      },
      expression: "queryParam.remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "export"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "button-container"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n        搜索\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "spacer"
  }), _vm._v(" "), _c('Row', [_c('Button', {
    attrs: {
      "type": "primary",
      "icon": "plus-round"
    },
    on: {
      "click": _vm.onInsertUser
    }
  }, [_vm._v("添加学生")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "archive"
    },
    on: {
      "click": _vm.bannedUser
    }
  }, [_vm._v("封禁\n        ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.exportLoading,
      "disable": _vm.exportLoading,
      "icon": "archive"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    ref: "dataList",
    attrs: {
      "tableColumns": _vm.title,
      "reload": _vm.reload,
      "listUrl": "/bookTest/list",
      "params": _vm.queryParam,
      "onLoading": _vm.onLoading
    },
    on: {
      "on-selection-change": _vm.selectionChange
    }
  }), _vm._v(" "), _c('UserInfoModal', {
    attrs: {
      "value": _vm.editUser,
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑渠道"
    },
    model: {
      value: (_vm.showEditRegTypeModal),
      callback: function($$v) {
        _vm.showEditRegTypeModal = $$v
      },
      expression: "showEditRegTypeModal"
    }
  }, [_c('Form', {
    ref: "editRegType",
    staticClass: "form",
    attrs: {
      "model": _vm.regTypeForm,
      "rules": _vm.regTypeRule
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "渠道",
      "prop": "regType",
      "label-width": 70
    }
  }, [_c('channel-select', {
    model: {
      value: (_vm.regTypeForm.regType),
      callback: function($$v) {
        _vm.$set(_vm.regTypeForm, "regType", $$v)
      },
      expression: "regTypeForm.regType"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showEditRegTypeModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error",
      "size": "large",
      "loading": _vm.loadingEditRegType
    },
    on: {
      "click": _vm.editRegType
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "修改推荐人"
    },
    model: {
      value: (_vm.showEditReferrerModal),
      callback: function($$v) {
        _vm.showEditReferrerModal = $$v
      },
      expression: "showEditReferrerModal"
    }
  }, [_c('Form', {
    ref: "editReferrer",
    staticClass: "form",
    attrs: {
      "model": _vm.referrerForm
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('StudentSelect', {
    attrs: {
      "label": _vm.inviteName
    },
    model: {
      value: (_vm.referrerForm.inviteId),
      callback: function($$v) {
        _vm.$set(_vm.referrerForm, "inviteId", $$v)
      },
      expression: "referrerForm.inviteId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showEditReferrerModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error",
      "size": "large",
      "loading": _vm.loadingEditReferrer
    },
    on: {
      "click": _vm.editReferrer
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "修改首次分配顾问"
    },
    model: {
      value: (_vm.showEditFirstConsultantModal),
      callback: function($$v) {
        _vm.showEditFirstConsultantModal = $$v
      },
      expression: "showEditFirstConsultantModal"
    }
  }, [_c('Form', {
    ref: "editFirstConsultant",
    staticClass: "form",
    attrs: {
      "model": _vm.firstConsultantForm
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 20
    }
  }, [_c('admin-user-select', {
    attrs: {
      "status": 1,
      "adminGroupCode": "adviser"
    },
    model: {
      value: (_vm.firstConsultantForm.adviserId),
      callback: function($$v) {
        _vm.$set(_vm.firstConsultantForm, "adviserId", $$v)
      },
      expression: "firstConsultantForm.adviserId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showEditFirstConsultantModal = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error",
      "size": "large",
      "loading": _vm.loadingEditFirstConsultant
    },
    on: {
      "click": _vm.editFirstConsultant
    }
  }, [_vm._v("确定\n      ")])], 1)], 1), _vm._v(" "), _c('InsertUserModal', {
    attrs: {
      "successCallback": _vm.search
    },
    model: {
      value: (_vm.showInsertUserModal),
      callback: function($$v) {
        _vm.showInsertUserModal = $$v
      },
      expression: "showInsertUserModal"
    }
  }), _vm._v(" "), _c('BannedUserModal', {
    attrs: {
      "successCallback": _vm.search,
      "userList": _vm.selectionUser
    },
    model: {
      value: (_vm.showBannedUserModal),
      callback: function($$v) {
        _vm.showBannedUserModal = $$v
      },
      expression: "showBannedUserModal"
    }
  }), _vm._v(" "), _c('AiDrawer', {
    attrs: {
      "visible": _vm.aiVisible,
      "uid": _vm.aiUid,
      "page-route": "/user/bookTestList",
      "default-task-type": "SALES_FOLLOWUP"
    },
    on: {
      "update:visible": function($event) {
        _vm.aiVisible = $event
      },
      "on-executed": _vm.onAiExecuted,
      "on-close": _vm.onAiClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-607b7d2c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/BookTestList.vue
// module id = 1842
// module chunks = 8